import React from 'react';

export default function Bio() {
	return (
		<div className="bio">
			{/* <h3>Bio</h3> */}
			<p>
				Hi, I’m a self-taught frontend developer passionate about building
				modern, responsive, and user-friendly web applications. I primarily work
				with React and JavaScript and I enjoy turning ideas into real projects
				while continuously improving my skills through hands-on development.{' '}
				<br />
				<br />
				I’m especially interested in understanding how applications are
				logically structured, how different technologies interact, and how
				scalable systems are designed and maintained. I enjoy problem-solving,
				improving application architecture, learning new technologies, and
				building projects that strengthen both my technical understanding and
				development skills.
				<br /> <br />
				Currently, I’m focused on building strong portfolio projects, gaining
				practical experience, and continuing my journey toward becoming a
				professional software developer.
			</p>
		</div>
	);
}
